import * as fromRoom from './rooms.reducer';
import * as fromConfirmation from './confirmation.reducer';
import { ActionReducerMap } from '@ngrx/store';
import * as fromUI from './ui.reducer';
import * as fromBooking from './booking.reducer';
import * as fromPayment from './payment.reducer';
import * as fromAdmin from './admin.reducer';

export interface State {
  booking: fromBooking.State;
  rooms: fromRoom.State;
  confirmation: fromConfirmation.State;
  ui: fromUI.State;
  payment: fromPayment.State;
  admin: fromAdmin.State;
}

export const reducers: ActionReducerMap<State> = {
  booking: fromBooking.reducer,
  rooms: fromRoom.reducer,
  confirmation: fromConfirmation.reducer,
  ui: fromUI.reducer,
  payment: fromPayment.reducer,
  admin: fromAdmin.reducer
};



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/reducers/index.ts